<template>
  <div v-if="me">
    <!-- 약관 내용 시작 -->
    <section class="px-4">
      <blockquote>
        <p>제1조 한도거래 및 개별거래</p>
        <p>
          한도거래 함은 거래 기간 중 한도 금액 범위 내에서 대출금을 자유롭게 신청하고 지급받는 것을,
          개별거래라 함은 대출 금액을 한도거래 기간 전 또는 만료일에 직접 일시 상환하거나 거래
          기간까지 분할하여 상환하는 것을 말한다.
        </p>
      </blockquote>

      <v-expansion-panels v-model="isTermOpen">
        <v-expansion-panel>
          <v-expansion-panel-header v-if="isTermOpen !== 0" hide-actions>
            <v-btn color="white" x-large block rounded :depressed="captureMode">
              <strong class="font-size--18 color--nice-grey">내용 더보기</strong>
            </v-btn>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <blockquote>
              <p>제2조 상환방식</p>
              <!-- <p>
                번개입금 선정산 또는 펌뱅킹 이체출금 금원의
                {{ repaymentRatio }}%를 상환재원으로하며, 대출금의 이자, 원금순으로 상환한다. 상환은
                선정산금원으로 진행하며, 선정산 중단 또는 매출 미발생시 고객의 직접납부 또는 펌뱅킹
                방식으로 납부한다.
              </p> -->
              <p>
                ① 고객의 사업장에서 발생하는 카드 및 배달 매출로 대출기간에 따라 원금분할 및 매출에
                따른 비율로 상환하며, 매출 미발생시 고객의 직접납부 또는 펌뱅킹 방식으로 납부한다.
                <br />
                ② 계약기간동안 채무자의 매출 하락으로 상환기간 대비 대출상환 비율이 부족할 경우
                채권자가 원금분할 금액 또는 상환비율을 상향시킬 수 있다.
              </p>
            </blockquote>

            <blockquote>
              <p>제3조 지연손해금</p>
              <p>
                이자, 분할상환금, 분할상환 원리금을 대출 만기일까지 전액 상환하지 못하거나 제4조에
                의한 기한의 이익을 상실한 때에는 그 다음날부터 남은 대출 잔액에 대해 연체이자율에
                의한 지연손해금을 지급하기로 한다.
              </p>
            </blockquote>

            <blockquote>
              <p>제4조 기한의 이익상실</p>
              <p>한도거래약서 특약사항 1호에 의한다.</p>
            </blockquote>

            <blockquote>
              <p>제5조 관할법원의 합의</p>
              <p>
                본 계약에 관하여 채무자의 책임있는 사유로 제4조 기한의 이익상실 특약사항에 관한
                사유가 발생되어 채권자와 채무자 사이에 소송의 필요가 생긴 때에는 그 채권의 관리를
                위하여 채권자 소재지 관할법원으로 한다.
              </p>
            </blockquote>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-btn
        v-if="isTermOpen === 0"
        x-large
        block
        rounded
        color="white"
        :depressed="captureMode"
        @click="isTermOpen = null"
      >
        <strong class="font-size--18 color--nice-grey">내용 접기</strong>
      </v-btn>
    </section>
    <!-- 약관 내용 끝 -->

    <!-- 특약 내용 시작 -->
    <section style="background-color: #f4faff" class="pa-4">
      <blockquote>
        <p>특약사항</p>

        <ol>
          <li>
            다음 각 항목에 해당하는 경우 별도의 통지 없이 기한의 이익을 상실한다.<br />
            가) 사업자 폐업이나 변경시 기한의 이익을 상실한다.<br />

            나) 고객이 사전 동의 없이 카드매출, (주)우아한형제들 등 배달매출이 5영업일 이상 발생되지
            않을 때 기한의 이익을 상실한다.<br />

            다) 제신고 된 카드사, (주)우아한형제들 등 배달매출 입금 계좌를 동의 없이 변경했을 시
            기한의 이익을 상실한다.<br />

            라) 제신고 된 계좌에 입금된 카드매출, (주)우아한형제들 등 배달매출금액을 동의 없이 출금
            했을 시 기한의 이익을 상실한다.<br />

            <!-- 마) 대출 채권 상환을 위한 일일 카드매출, (주)우아한형제들 등 배달매출대금 입금액의
            {{ repaymentRatio }}%는 절대 중도인출이 불가능하며 채무자는 이의를 제기할 수 없다.<br /> -->

            마) 위 내용을 위반하여 기한의 이익이 상실할 경우 카드매출, (주)우아한형제들 등
            배달매출대금 입금액의 상환 비율을 '㈜펀다에이아이'에서 조정할 수 있으며, 채무자는 이의를
            제기할 수 없다.<br /><br />
          </li>

          <li>
            다음 각 항목에 해당하는 경우 모집된 금액은 자동으로 취소가 된다.<br />
            가) 대출 신청 이후, 특약 1호를 위반하는 사유가 확인된 경우<br /><br />
          </li>

          <li>
            플랫폼 이용 수수료<br />
            가) 대출금액의
            {{ isPreview ? '' : (loan.offer.commissionRate * 100).toFixed(2) }}%(부가세포함)에
            해당하는 플랫폼 이용 수수료를 대출 실행후, 다음영업일부터 대출자의 사업장에서 발생하는
            카드매출 및 배달매출 입금액에서 우선 수취한다.<br /><br />

            나) 플랫폼 이용수수료는 이자를 포함하여 연 20%를 초과 할 수 없으며, 완제 및 중도 상환 시
            이자를 포함한 금액이 연 20%를 초과할 경우 계약이 종료 된 날로부터 5영업일 이내
            대출자에게 반환한다.<br /><br />
          </li>

          <li>
            펀딩조건에 따라 고객(펀딩참여자)에게 발급되어 지급된 청구 할인금액은(비씨카드사에서
            "펀딩매장"에 정산 시 공제한 금액)은 비씨카드가맹점 매출대금 입금 시 가맹점수수료와 함께
            선 공제 후 입금되는 것에 동의하며, 비씨카드사에 이의를 제기하지 않는다.
          </li>
        </ol>
      </blockquote>

      <blockquote>
        <p>경남은행 펌뱅킹 이용에 관한 특약</p>

        <p>(지정 계좌의 개설 및 등록)</p>
        <p>
          ① 차주는 본 계약에 따른 대출금의 실행 및 상환을 위하여 펀다가 지정하는 BNK 경남은행
          계좌(이하 "지정 계좌")를 개설하고 이를 유지하여야 한다.
        </p>
        <p>
          ② 차주는 지정 계좌를 펀다가 운영하는 전산시스템에 등록하여야 하며, 이를 위하여
          자동응답시스템(ARS) 인증 등 펀다가 요구하는 본인확인 절차를 완료하여야 한다.
        </p>
        <p>
          ③ 차주는 대출기간 동안 카드매출, 배달앱 정산금, 기타 영업 매출 및 이에 준하는 수입금이
          지정 계좌로 입금되도록 조치하여야 한다.
        </p>

        <p>(펌뱅킹 서비스 이용 동의)</p>
        <p>
          ① 차주는 펀다가 지정 계좌와 연계된 펌뱅킹 서비스를 이용하여 지정 계좌의 입출금 내역을
          조회하고, 본 계약에 따른 상환금 상당액을 자동으로 출금하는 것에 동의한다.
        </p>
        <p>
          ② 차주는 본 계약 체결 및 특약 동의를 통해 펀다가 상환 업무 수행을 위하여 다음 각 호의
          행위를 하는 것에 명시적으로 동의한다.
        </p>

        <ol>
          <li>지정 계좌에서 상환금 상당액의 자동 출금</li>
          <li>상환금 충당 후 잔여 금원의 지정 계좌로 재입금 또는 반환</li>
          <li>상환 및 정산을 위한 전산 처리</li>
        </ol>
        <p>
          ③ 펀다는 지정 계좌(회수전용계좌)의 운영 목적에 따라 본 계약에 따른 상환금 상당액을
          펌뱅킹을 통하여 출금할 수 있으며, 이는 대출 상환 및 선정산금 회수를 위한 일시적인 자금
          이동으로서 처리된다.
        </p>
        <p>
          ④ 펀다는 전항에 따라 출금된 금액 중 본 계약에 따른 상환금(피담보채권)에 해당하는 금액을
          우선 충당하고, 이를 초과하는 잔여 금액은 고객이 지정한 계좌로 반환한다.
        </p>

        <p>(출금제한의 설정 및 책임)</p>
        <p>
          ① BNK 경남은행은 펀다의 요청에 따라 지정 계좌에 대한 출금제한을 설정하며, 펀다가 제출한
          차주(고객) 동의 정보의 진정성이나 요건 충족 여부를 별도로 확인하거나 검증할 의무를 지지
          아니한다. 펀다의 요청에 오류 또는 하자가 있어 발생한 모든 책임은 펀다가 전적으로 부담한다.
        </p>

        <p>(이의제기 및 분쟁처리)</p>
        <p>
          ① 차주(고객)가 출금제한 또는 자금이체에 관하여 이의를 제기하거나 분쟁이 발생하는 경우,
          펀다는 자신의 책임과 비용으로 해당 민원을 전적으로 접수 및 처리하여 BNK 경남은행을
          면책한다.
        </p>

        <p>(손해배상)</p>
        <p>
          ① 펀다는 차주(고객)와의 계약 관계, 출금제한 설정 및 펌뱅킹 이체와 관련하여 발생하는 모든
          손해 및 분쟁에 대하여 전적인 책임을 부담하며, 이로 인해 BNK 경남은행에 손해가 발생한 경우
          이를 전액 배상한다.
        </p>

        <p>(서비스 해지 시 자동이체 및 출금제한 해제)</p>
        <p>
          ① 펀다는 차주(고객)가 서비스를 해지하거나 철회하는 경우 지정 계좌의 자동 이체 및 출금제한
          조치를 가능한 한 신속히 해제한다. 다만, 차주(고객)의 대출 잔액이 남아 있는 경우에는 최종
          상환이 완료될 때까지 자동 이체 및 출금제한 조치를 지속할 수 있다.
        </p>
      </blockquote>

      <blockquote>
        <p>채권양도승낙서 및 위임장</p>
        <p>
          (주)펀다에이아이 - 본인은 본 계약서에 의하여 귀사가 본인에대해서 가지고 있는 금전채권 및
          계약상 본인에 대하여 갖는일체의 권리(계약해제권을 포함한 계약자로서 갖는 모 든 권리)(이하
          ‘본건 대출’채권이라함)를 귀사가    년   월   일  (이하‘양수인’이라 함)     에게 채권매각을
          위하여 양도함에 아무런이의 없이 승낙합니다. 이와 관 련하여 본인은 귀사가 본인을대리하여
          승낙할 수 있는 권한(위 양도관 련백지부분을 보충할 수있는 권한을 포함)을 위 임합니다. 단,
          본건 대출채권의 이자 및원금은 양수인이 별도 서면청구에 기재된 방법에 따라 본건대출채권의
          이자 및 원금은 양수인이 별도 서면 청구에 기재된방법에 따라 본건 대출채권의 이자 및 원금을
          양수인에게 직접납입하도록 하겠습니다. 또한, 본인은 귀사가 본인으로부터 취득한 상기
          개인신용정보를 채권의 양도에 따라 양수인으로부터채권 추심등의 업무를 위탁 받은자에게
          제공되는 것에 대해서도이의 없이 동의합니다.
        </p>
      </blockquote>
    </section>
    <!-- 특약 내용 끝 -->

    <!-- 약관 동의 버튼 시작 -->
    <section class="px-4">
      <ContractAgreeButton
        ref="one"
        prefix="1. "
        btn-text="수령함"
        description="위 계약서 및 온라인연계 대출계약 약관을 확실히 수령하였습니까?"
        :is-agree.sync="agreeForm.one"
      />

      <ContractAgreeButton
        ref="two"
        prefix="2. "
        btn-text="들었음"
        description="위 계약서 및 온라인연계 대출계약 약관의 중요한 내용에 대하여 설명을 들었습니까?"
        :is-agree.sync="agreeForm.two"
      />

      <ContractAgreeButton
        ref="three"
        prefix="3. "
        btn-text="들었음"
        description="중개수수료를 채무자로부터 받는 것이 불법이라는 설명을 들었습니까?"
        :is-agree.sync="agreeForm.three"
      />
    </section>
    <!-- 약관 동의 버튼 끝 -->

    <!-- 서명란 시작 -->
    <section class="pt-4 text-center">
      <p>{{ isPreview ? '' : $moment().format('YYYY년 MM월 DD일') }}</p>
      <p>
        성명 <b>{{ me.name }}</b>
      </p>

      <ContractAgreeSign ref="sign" @sign="sign" />
    </section>
    <!-- 서명란 끝 -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import checkAgreeMixin from './checkAgreeMixin'
import { toPercentage } from '@/util/mathUtil'

export default {
  components: {
    ContractAgreeButton: () => import('@/components/loan/contract/input/ContractAgreeButton.vue'),
    ContractAgreeSign: () => import('@/components/loan/contract/input/ContractAgreeSign.vue'),
  },
  mixins: [checkAgreeMixin],
  data() {
    return {
      isTermOpen: null,
      agreeForm: {
        one: false,
        two: false,
        three: false,
        sign: false,
      },
    }
  },
  watch: {
    captureMode: {
      immediate: true,
      handler(v) {
        if (v) {
          this.isTermOpen = 0
        }
      },
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('ui', ['captureMode']),
    /**
     * 상환비율
     */
    repaymentRatio() {
      return this.loan.offer.repaymentRatio ? toPercentage(this.loan.offer.repaymentRatio, 0) : 10
    },
    isPreview() {
      return this.loan?.__preview === true
    },
  },
  methods: {
    toPercentage,
    sign(signature) {
      this.agreeForm.sign = true
      this.$emit('sign', signature)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .layout .flex ul li {
  font-size: 14px;
  font-weight: 500;
}

section {
  margin: 30px 0;
}

.agree-button {
  margin-bottom: 16px;
}

.v-expansion-panel {
  &-header {
    padding: 0;
  }

  &::before {
    box-shadow: none;
  }
}

blockquote {
  margin-bottom: 24px;

  p:first-of-type {
    font-weight: bold;
  }
  p:last-of-type {
    line-height: 1.4;
  }
}

::v-deep > .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
